import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

/*
 * React.StrictMode is intentionally not used here. In development it
 * double-invokes every effect (mount -> cleanup -> mount again) to help
 * surface effects that aren't safe to run twice. Most of this app's pages
 * are deliberate ports of the original jQuery/DOM scripts running inside
 * useEffect (see the page components for why), so re-running one of those
 * scripts a second time before its first run has even settled can
 * double-bind click handlers — that's what caused the Admin Dashboard's
 * "Exam" sidebar menu to open and immediately snap shut again. It only ever
 * happened in `npm start` dev builds; `npm run build` never double-invokes
 * effects regardless of StrictMode, so this has no effect on production
 * behaviour either way.
 */
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

